import React, { useContext, useEffect } from 'react';
import { useStyles } from './AllSortedStyles';
import { DocumentTitle, Typography, YourCoverReceipt, NextSteps, StepChecker } from '../../components/atoms';
import PageTemplate from '../../templates/PageTemplate';
import { StepContext } from '../../contexts/StepContext';
import { Grid, Box } from '@material-ui/core';
import clsx from 'clsx';

export const AllSorted: React.FC = () => {
  const { data, updateShowStepper, updateActiveStep } = useContext(StepContext);
  const classes = useStyles();

  useEffect(() => {
    window.scrollTo(0, 0);
    updateActiveStep(6);
    updateShowStepper(false);
    // Guard against gtag not being available (consent not given, blocked, or not loaded yet)
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', {
        allow_custom_scripts: true,
        send_to: 'DC-3535201/gffleet/confleet+standard',
      });
    } else {
      console.warn('gtag is not available - conversion tracking skipped');
    }
  }, []);

  return (
    <PageTemplate>
      <StepChecker />
      <DocumentTitle title={`DLG ${process.env.REACT_APP_SITE_ID} - All Sorted`} />
      <Box className={classes.bgImage}>
        <Box className={classes.allSortedContainer}>
          <Typography className={classes.allSortedHeading} variant="h1">
            ALL SORTED!
          </Typography>
        </Box>

        <Grid className={classes.gridMainContainer}>
          <Grid item xs={12} lg={12} className={classes.gridMain}>
            <Box margin={'1rem 0'}>
              <Typography className={classes.welcome} variant="h1">
                Here&apos;s all the important info about your cover.
              </Typography>
            </Box>
            <Box display={'flex'} flexDirection={'column'} justifyContent={'center'}>
              <YourCoverReceipt
                startDate={data.coverStartDate}
                coverType={data.coverType}
                vehicleCount={data.vehicleCount}
              />
            </Box>
            <NextSteps />
            <Box className={classes.subHeadingSpacing}>
              <Typography className={clsx(classes.greenExitText, 'mb1')}>RIGHT, THAT&apos;S ENOUGH FROM US.</Typography>
              <Typography className={classes.greenExitText}>GO ENJOY THE REST OF YOUR DAY!</Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </PageTemplate>
  );
};

export default AllSorted;
